import { ssoLogout } from "../../utils/sso/config";
import {
  Message,
  PhotoCamera,
  Save,
  SecurityOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import styles from "./settings.module.scss";
import PROFILE_PIC from "../../assets/images/profileImg.png";
import { axiosGet, axiosPut } from "../../utils/common/axios";
import { useS3Upload } from "../../customHooks/S3Upload";
import { toast } from "react-hot-toast";
import { setCookie } from "../../utils/common/cookies";
import { useNavigate, useParams } from "react-router-dom";
import {
  getUserById,
  updateUser,
  updateUserPassword,
} from "../../store/actions";
import { DESTINATIONS } from "../../utils/common/constants";

const InitialState = {
  fullName: "",
  phoneNumber: "",
  email: "",
  imageUrl: "",
};

const IntialPasswdState = {
  password: "",
  confirmPassword: "",
};

const normalizeValue = (value) => {
  if (value === undefined || value === null) {
    return "";
  }

  return value.toString().trim();
};

const Settings = ({ user, userDetail }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [images, uploadImages] = useS3Upload();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [userDetails, setUserDetails] = useState(InitialState);
  const [passwd, setPasswd] = useState(IntialPasswdState);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  console.log("Setting", params?.settingsType);
  console.log("Setting UserDetails", userDetails);

  const logout = () => {
    dispatch({ type: "LOGOUT_USER" });
    ssoLogout();
  };

  useEffect(() => {
    if (params.settingsType === "edit" || params.settingsType === "add") {
      return;
    } else {
      dispatch(
        getUserById({
          id: user.id,
          callback: {
            success: () => {},
          },
        })
      );
    }
  }, [params.settingsType]);

  useEffect(() => {
    if (params.settingsType === "add") {
      return;
    } else {
      setUserDetails({
        fullName: user?.fullName || "",
        phoneNumber: user?.phoneNumber?.toString() || "",
        email: user?.email || "",
        role: user?.role || "",
        status: user?.status?.toString() || "",
        imageUrl: user?.imageUrl || "",
      });
    }
  }, []);

  // console.log("userDetail", userDetail);
  const isPasswordMatched =
    passwd.confirmPassword?.length >=5&&
    passwd.password?.length >=5 &&
    passwd.confirmPassword === passwd.password;

  const handleUploadFiles = async (e, key, destination) => {
    const files = e.target.files;
    if (files?.length > 0) {
      const uploadUrl = await uploadImages(key, files[0], destination);
      setUserDetails({
        ...userDetails,
        imageUrl: uploadUrl,
      });
    }
  };

  const onInputChange = (key, value = "") => {
    setUserDetails({
      ...userDetails,
      [key]: value,
    });
  };

  const onPasswordChange = (key, value = "") => {
    setPasswd({
      ...passwd,
      [key]: value,
    });
  };

  const onChangePassword = async () => {
    const payload = {
      username: user?.phoneNumber?.toString(),
      password: passwd?.password,
    };
    console.log("user password", payload);
    dispatch(
      updateUserPassword({
        payload: payload,
        callback: {
          success: () => {
            logout();
          },
        },
      })
    );
  };

  const onSave = async () => {
    const payload = {
      fullName: userDetails?.fullName,
      phoneNumber: userDetails?.phoneNumber,
      email: userDetails?.email,
      imageUrl: userDetails?.imageUrl,
    };

    console.log("user details", payload);

    dispatch(
      updateUser({
        payload: { ...user, ...payload },
        callback: {
          success: () => {
            logout();
          },
        },
      })
    );
  };

  const normalizedUserDetails = {
    fullName: normalizeValue(userDetails?.fullName),
    phoneNumber: normalizeValue(userDetails?.phoneNumber),
    email: normalizeValue(userDetails?.email),
    imageUrl: normalizeValue(userDetails?.imageUrl),
  };

  const normalizedUser = {
    fullName: normalizeValue(user?.fullName),
    phoneNumber: normalizeValue(user?.phoneNumber),
    email: normalizeValue(user?.email),
    imageUrl: normalizeValue(user?.imageUrl),
  };

  const hasChanges = Object.keys(normalizedUserDetails).some(
    (key) => normalizedUserDetails[key] !== normalizedUser[key]
  );

  const isValid =
    normalizedUserDetails.fullName.length > 3 &&
    normalizedUserDetails.phoneNumber.length === 10 &&
    normalizedUserDetails.email.length > 3;
  // Boolean(normalizedUserDetails.imageUrl);

  console.log(hasChanges, "hasChanges");

  const isSaveEnabledEdit = !hasChanges || !isValid;
  console.log(isSaveEnabledEdit, "isSaveEnabledEdit");

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <Paper className={styles.wrapper}>
        <Row className={styles.titleContainer}>
          <Col className={styles.title}>User Account Details</Col>
        </Row>
        <Row className={styles.profilePicRow}>
          <Col className={styles.profilePicContainer}>
            <img
              src={userDetails.imageUrl || PROFILE_PIC}
              alt=""
              className={styles.profilePic}
            />
          </Col>
          <Col className={styles.profilePicActionContainer}>
            <div className={styles.buttonsContainer}>
              <Button
                variant="contained"
                startIcon={<PhotoCamera />}
                component="label"
                classes={{ contained: styles.button1 }}
              >
                Upload photo
                <input
                  onChange={(e) =>
                    handleUploadFiles(
                      e,
                      "profilePic",
                      DESTINATIONS.USER_DETAILS
                    )
                  }
                  type="file"
                  accept="image/*"
                  hidden
                />
              </Button>
            </div>
            {/* <div className={styles.picUploadInfo}>
              Allowed PNG or JPEG. Max size of 500K.
            </div> */}
          </Col>
        </Row>
        <hr className={styles.dividerLine} />
        <div className={styles.formWrapper}>
          <Row className={styles.inputRow}>
            <Col className={styles.inputCol}>
              <FormControl required fullWidth>
                <InputLabel htmlFor="outline-input-firstname">
                  User Name
                </InputLabel>
                <OutlinedInput
                  value={userDetails?.fullName}
                  onChange={(e) => onInputChange("fullName", e?.target?.value)}
                  className={styles.input}
                  id="outline-input-firstname"
                  label="User Name"
                />
              </FormControl>
            </Col>
          </Row>
          <Row className={styles.inputRow}>
            <Col className={styles.inputCol}>
              <FormControl fullWidth>
                <InputLabel htmlFor="outline-input-lastname">
                  Phone Number
                </InputLabel>
                <OutlinedInput
                  value={userDetails?.phoneNumber}
                  onChange={(e) =>
                    onInputChange("phoneNumber", e?.target?.value)
                  }
                  className={styles.input}
                  id="outline-input-lastname"
                  label="Phone Number"
                  inputProps={{ maxLength: 10 }}
                />
              </FormControl>
            </Col>
          </Row>
          <Row className={styles.inputRow}>
            <Col className={styles.inputCol}>
              <FormControl fullWidth>
                <InputLabel htmlFor="outline-input-emailid">
                  Email ID
                </InputLabel>
                <OutlinedInput
                  value={userDetails?.email}
                  onChange={(e) => onInputChange("email", e?.target?.value)}
                  className={styles.input}
                  id="outline-input-emailid"
                  label="Email ID"
                />
              </FormControl>
            </Col>
          </Row>
          <Row className={styles.formButtonRow}>
            <Col className={styles.formBtnContainer}>
              <Button
                variant="contained"
                color="error"
                component="label"
                classes={{ contained: styles.button }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.formBtnContainer}>
              <Button
                onClick={onSave}
                disabled={isSaveEnabledEdit}
                variant="contained"
                color="success"
                startIcon={<Save />}
                classes={{ contained: styles.button }}
              >
                {" "}
                Save Changes
              </Button>
            </Col>
          </Row>
        </div>
      </Paper>
      {/* PASSOWORD HANDLING FEILDS */}
      <Paper className={styles.wrapper}>
        <div className={styles.formWrapper}>
          <Row className={styles.titleContainer}>
            <Col className={styles.title}>Change Password</Col>
          </Row>
          <Row className={styles.inputRow}>
            <Col className={styles.inputCol}>
              <FormControl variant="outlined" fullWidth autoComplete="off">
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  className={styles.input}
                  value={passwd.password}
                  onChange={(e) =>
                    onPasswordChange("password", e?.target?.value)
                  }
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        // onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                <FormHelperText>
                  Password should be at least 5 Characters
                </FormHelperText>
              </FormControl>
            </Col>
            <Col className={styles.inputCol}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-password">
                  Confirm Password
                </InputLabel>
                <OutlinedInput
                  className={styles.input}
                  value={passwd.confirmPassword}
                  onChange={(e) =>
                    onPasswordChange("confirmPassword", e?.target?.value)
                  }
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        // onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm Password"
                />
                <FormHelperText>
                  Password should be at least 5 Characters
                </FormHelperText>
              </FormControl>
            </Col>
          </Row>
          <Row className={styles.formButtonRow}>
            <Col className={styles.formBtnContainer}>
              <Button
                onClick={onChangePassword}
                disabled={!isPasswordMatched}
                variant="contained"
                color="success"
                startIcon={<SecurityOutlined />}
                classes={{ contained: styles.button }}
              >
                {" "}
                Change Passowrd
              </Button>
            </Col>
          </Row>
        </div>
      </Paper>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.login?.user,
  };
};

export default connect(mapStateToProps, null)(Settings);
